<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h1"><span><i>EXPRESSIONS OF LOVE</i></span></p>
<p class="part-h2"><span>A Novel</span></p>
<p class="part-left">“When a woman loves a woman,</p>
<p class="part-left1">it is the blood of the mothers speaking.”</p>
<p class="part-left">—Caribbean proverb</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6d2b3765